import BookNow from './BookNow';

export default BookNow;